import React, { useState, useEffect } from 'react';
import './Header.css';
import PixelIcon from './PixelIcon';

function Header({ lastUpdated, onOpenWhitePaper }) {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [timeSinceUpdate, setTimeSinceUpdate] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (lastUpdated) {
      const updateTime = () => {
        const now = new Date();
        const diff = Math.floor((now - new Date(lastUpdated)) / 1000);
        
        if (diff < 60) {
          setTimeSinceUpdate(`${diff}s ago`);
        } else if (diff < 3600) {
          setTimeSinceUpdate(`${Math.floor(diff / 60)}m ago`);
        } else if (diff < 86400) {
          setTimeSinceUpdate(`${Math.floor(diff / 3600)}h ago`);
        } else {
          setTimeSinceUpdate(`${Math.floor(diff / 86400)}d ago`);
        }
      };

      updateTime();
      const timer = setInterval(updateTime, 1000);
      return () => clearInterval(timer);
    }
  }, [lastUpdated]);

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <div className="logo-container">
            <div className="logo-text">
              <span className="logo-icon"><PixelIcon name="bolt" size={22} /></span>
              <span className="glow-text">AI-MAGEDDON</span>
            </div>
            <div className="logo-subtitle text-secondary">
              SCENARIO MONITORING SYSTEM
            </div>
          </div>
        </div>
        
        <button 
          className={`hamburger-menu ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        
        <div className={`header-right ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <button className="whitepaper-btn" onClick={onOpenWhitePaper}>
            Methodology
          </button>
          <div className="live-data-badge" title="Data refreshes every 30 seconds">
            <span className="live-indicator"></span>
            <span className="text-green">LIVE</span>
            {timeSinceUpdate && <span className="text-secondary">· updated {timeSinceUpdate}</span>}
          </div>
          <div className="timestamp text-secondary">
            {currentTime.toLocaleString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
            })}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
